import React from 'react';
import { TextField, Grid } from '@material-ui/core';
import { useFormContext, Controller } from 'react-hook-form';

const CustomTextField = ({name, label}) => {
  const { control } = useFormContext();

  return (
    <Grid item xs={12} sm={6}>
      <Controller
        render={({ field }) => (
          <TextField {...field} defaultValue="" label={label} fullWidth  multiline rows={4}/>
        )}
        control={control}
        name={name}
      />
    </Grid>
  );
}

export default CustomTextField;
